import React from "react";
import { AsyncTypeahead } from "@countysuite/ui";
import { CaseSearchResult } from "types/CivilTypes";
import "./TsCaseSearch.scss";

export type Props = {
  id: string;
  onSearch: (searchText: string) => Promise<any>;
  options: any;
  onChange: any;
  label?: string;
  placeholder?: string;
  value?: CaseSearchResult;
  renderMenuItemChildren?: (
    option: CaseSearchResult,
    typeaheadProps: any,
    index: number
  ) => React.ReactNode | undefined;
};

/**
 * Provides a default label and menu rendering for TsAsyncTypeahead.
 * Assumes you will use CaseSearchResult as your data type,
 * and debounces your onSearch by half a second.
 * @param props
 */
export const TsCaseSearch: React.FC<Props> = (props) => {
  return (
    <AsyncTypeahead
      name={props.id + "-casesearch"}
      id={props.id}
      label="Search for Additional Cases"
      placeholder="Type to search for cases"
      onChange={props.onChange}
      getOptionLabel={(o: CaseSearchResult) => o.caseNumber}
      value={props.value || null}
      renderMenuItemChildren={(option: CaseSearchResult) => (
        <div>
          <div>
            <strong>
              {option.caseNumber}
              {option.isCaseClosed ? " [CLOSED]" : ""}
            </strong>
          </div>
          <div>
            <em>{option.caseCaption}</em>
          </div>
        </div>
      )}
      onSearch={props.onSearch}
    />
  );
};
